import BackgroundText from "../common/BackgroundText";
import ImageTitleWithDescription from "../common/ImageTitleWithDescription";
import GlowEffect from "../common/GlowEffect";
import { useNavigate } from "react-router-dom";
import { useInsightsData } from "../../hooks/useInsightsData";

export default function EventsSection() {
  const navigate = useNavigate();
  const { data } = useInsightsData();
  
  const handleKnowMore = (id: string) => {
    navigate(`/insights/events/${id}`);
  };

  return (
    <div className="py-10 relative">
      <GlowEffect direction="left" />
      <div className="container mx-auto px-5 sm:px-10 relative z-10">
        <BackgroundText text="Events" />
        <ImageTitleWithDescription data={data.eventsPosts} handleKnowMore={handleKnowMore} />
      </div>
    </div>
  );
}
